import { Link } from "react-router-dom";
import { Wrench, Lock } from "lucide-react";
import { BUSINESS } from "@/lib/data";
import { scrollToHash } from "@/components/Navbar";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-[#0B0E11]">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 py-16">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-9 h-9 rounded-sm bg-[#E06A26] flex items-center justify-center">
                <Wrench className="w-4.5 h-4.5 text-[#0F1215]" strokeWidth={2.5} />
              </span>
              <span className="font-display font-extrabold tracking-[0.18em] text-lg">
                THOR<span className="text-[#E06A26]">TEK</span>
              </span>
            </div>
            <p className="text-sm text-[#94A0AC] leading-relaxed max-w-sm">{BUSINESS.tagline}. Licensed & insured in the State of Texas.</p>
            <p className="font-display text-4xl sm:text-5xl font-extrabold text-outline mt-10 select-none">THORTEK</p>
          </div>

          <div className="md:col-span-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#606D7A] mb-5">Contact</p>
            <a href={BUSINESS.phoneHref} className="block text-sm text-[#F4F2EE]/85 hover:text-[#E06A26] transition-colors mb-3">{BUSINESS.phone}</a>
            <a href={`mailto:${BUSINESS.email}`} className="block text-sm text-[#F4F2EE]/85 hover:text-[#E06A26] transition-colors break-all">{BUSINESS.email}</a>
            <p className="font-mono text-[11px] text-[#94A0AC] mt-3">Rahway, NJ</p>
            <div className="mt-6 space-y-2">
              {BUSINESS.hours.map((h) => (
                <p key={h.days} className="font-mono text-[11px] text-[#606D7A]">{h.days} — {h.time}</p>
              ))}
            </div>
          </div>

          <div className="md:col-span-2">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#606D7A] mb-5">Explore</p>
            {[["Services", "#services"], ["Maintenance", "#maintenance"], ["Craft", "#manifesto"], ["Reviews", "#reviews"], ["Book now", "#contact"]].map(([label, href]) => (
              <a key={href} href={href} onClick={(e) => { e.preventDefault(); scrollToHash(href); }} className="block text-sm text-[#94A0AC] hover:text-[#F4F2EE] transition-colors mb-3">
                {label}
              </a>
            ))}
          </div>

          <div className="md:col-span-2">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#606D7A] mb-5">Office</p>
            <Link to="/admin/login" data-testid="footer-admin-link" className="inline-flex items-center gap-2 text-sm text-[#94A0AC] hover:text-[#E06A26] transition-colors">
              <Lock className="w-3.5 h-3.5" /> Admin login
            </Link>
          </div>
        </div>

        <div className="border-t border-white/10 mt-14 pt-8 flex flex-wrap items-center justify-between gap-4">
          <p className="font-mono text-[11px] text-[#606D7A]">© {new Date().getFullYear()} {BUSINESS.name}. All rights reserved.</p>
          <p className="font-mono text-[11px] text-[#606D7A]">Central NJ · North NJ · Rahway · Westfield · Summit</p>
        </div>
      </div>
    </footer>
  );
}
